import { CATALOG_SECTIONS, NETFLIX_PRODUCT_OFFERING, NETFLIX_PRODUCT_OFFERING_NEW, OTHERS } from "@/constants/constants";

export const getMovistarPlusLiteActivationURL = (token) => {
  if (token) {
    let activationURL = null;
    const { origin } = window.location;
    if (
      origin.indexOf("movistar.es.inte") > -1 ||
      origin.indexOf("movistar.es.cert") > -1
    ) {
      activationURL = "https://sta.litemovistarplus.es/movistar/";
    } else {
      activationURL = "https://contratar.movistarplus.es/movistar/";
    }
    activationURL += `?token=${token}`;

    return activationURL;
  }
  return false;
};

export const getMovistarPlusLiteURL = (
  movistarLiteStatus,
  movistarLiteActivation
) => {
  let returnURL = "https://ver.movistarplus.es/";
  let auxMovistarPlusLiteActive = false;
  if (movistarLiteStatus && movistarLiteStatus.products) {
    const { products } = movistarLiteStatus;
    if (Array.isArray(products) && products.length > 0) {
      const movistarPlusLiteProduct = products[0];
      auxMovistarPlusLiteActive = movistarPlusLiteProduct.active;
    }
  }
  if (
    !auxMovistarPlusLiteActive &&
    movistarLiteActivation &&
    movistarLiteActivation.jwt
  ) {
    returnURL = getMovistarPlusLiteActivationURL(movistarLiteActivation.jwt);
  }
  return returnURL;
};

export const ZONIFICACION_ZONES = {
  MIXED: "Zona Mixta",
  REGULATED: "Zona Regulada",
  FREE: "Zona Libre",
};
export const ZONIFICACION_ZONES_BY_HEADER = {
  MIXED: "ZM",
  REGULATED: "ZR",
  FREE: "ZL",
};

export const ZONIFICACION_ZONES_IDS = {
  [ZONIFICACION_ZONES.FREE]: "600001",
  [ZONIFICACION_ZONES.REGULATED]: "600000",
  [ZONIFICACION_ZONES.MIXED]: "",
};

export const ZONIFICACION_ZONES_IDS_TRADUCTOR_HEADER = {
  600001: ZONIFICACION_ZONES_BY_HEADER.FREE,
  600000: ZONIFICACION_ZONES_BY_HEADER.REGULATED,
};

export const ZONIFICACION_HEADER_TO_CODE = {
  [ZONIFICACION_ZONES_BY_HEADER.FREE]: "600001",
  [ZONIFICACION_ZONES_BY_HEADER.REGULATED]: "600000",
  [ZONIFICACION_ZONES_BY_HEADER.MIXED]: "",
};

export const ZONIFICACION_ZONES_TAGGEO = {
  REGULATED: "regulada",
  FREE: "libre",
};

export const getZonaToName = (businessZoneId) => {
  let getZonaName = businessZoneId;

  //Se ha decidido ponerlo a fuego
  return ZONIFICACION_HEADER_TO_CODE["ZL"];
};

export const hasNetflixProduct = (tvProductId, hiredProducts) => {
  const filteredProducts = hiredProducts.filter(
    (product) =>
      (product.poId === NETFLIX_PRODUCT_OFFERING || product.poId === NETFLIX_PRODUCT_OFFERING_NEW) && product.parentProductId === tvProductId
  );

  return filteredProducts.length > 0 ? true : false;
};

export const hasMovistarPlus = (hiredProducts) => {
  const filteredProducts = hiredProducts.filter(
    ({ subseccion, productType, productOfferingTypes }) =>
      // subseccion === CATALOG_SECTIONS.VERTICALS.SUB_SECTIONS.COMMUNICATIONS &&
      productType === OTHERS &&
      productOfferingTypes.some(({ id }) => id === "51")
  );

  return filteredProducts.length > 0 ? true : false;
};

export const getMovistarPlusNoti = (hiredProducts) => {
  const filteredProducts = hiredProducts.filter(
    ({ subseccion, productType, productOfferingTypes }) =>
      subseccion === CATALOG_SECTIONS.VERTICALS.SUB_SECTIONS.COMMUNICATIONS &&
      productType === OTHERS &&
      productOfferingTypes.some(({ id }) => id === "51")
  );

  return filteredProducts
};
